module.exports = __webpack_public_path__ + "img/img42.429d38d7.png";